var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmerygencyContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75758 12.6666V11.2878H3.86061L5.22217 6.75505C5.31409 6.45631 5.48368 6.21801 5.73094 6.04015C5.9782 5.86228 6.25097 5.77312 6.54925 5.77266H8.61744C8.91617 5.77266 9.18917 5.86182 9.43644 6.04015C9.6837 6.21847 9.85306 6.45677 9.94452 6.75505L11.3061 11.2878H12.4091V12.6666H2.75758ZM6.89395 4.39387V0.946899H8.27274V4.39387H6.89395ZM10.9958 6.10013L10.0135 5.11774L12.4608 2.68762L13.426 3.65277L10.9958 6.10013ZM11.7197 9.21964V7.84085H15.1667V9.21964H11.7197ZM4.17084 6.10013L1.74072 3.65277L2.70588 2.68762L5.15323 5.11774L4.17084 6.10013ZM0 9.21964V7.84085H3.44697V9.21964H0Z",
    fill: "#D24343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerygencyContact);
export default __webpack_public_path__ + "static/media/emerygency-contact.dd792d991b0bc3b0e93ec782cdb67f8c.svg";
export { ForwardRef as ReactComponent };